const AlarmIcon = 'icons/theory/alarm-icon.svg'
const Algebra = 'icons/theory/algebra-cover.svg'
const AlgebraIcon = 'icons/theory/5xy-icon.svg'
const CakeDiagramIcon = 'icons/theory/cakediagram-icon.svg'
const DiceIcon = 'icons/theory/dice-icon.svg'
const EconomyIcon = 'icons/theory/economy-icon.svg'
const EquivIcon = 'icons/theory/equiv-icon.svg'
const Functions = 'icons/theory/functions-image.svg'
const Geometry = 'icons/theory/geometry-image.svg'
const GeometryIcon = 'icons/theory/geometry-icon.svg'
const GraphIcon = 'icons/theory/graph-icon.svg'
const Measurement = 'icons/theory/numbers_and_measurements-image.svg'
const MeasurementIcon = 'icons/theory/measurement-icon.svg'
const Proofs = 'icons/theory/proofs-image.svg'
const Statistics = 'icons/theory/statistics-image.svg'

interface ImageDataType {
  keyMatchers: string[]
  image?: {
    src: string
    alt?: string
  }
  icon?: {
    src: string
    alt?: string
  }
}

export const imageData: ImageDataType[] = [
  {
    keyMatchers: ['number', 'tall', 'chysla-ta-velychyny'],
    image: {
      src: Measurement,
      alt: '',
    },
    icon: {
      src: MeasurementIcon,
      alt: 'numbersAndQuantitiesIcon',
    },
  },
  {
    keyMatchers: ['algebra', 'alhebra'],
    image: {
      src: Algebra,
    },
    icon: {
      src: AlgebraIcon,
      alt: 'algebraIcon',
    },
  },
  {
    keyMatchers: ['geometry', 'geometri', 'heometriya'],
    image: {
      src: Geometry,
    },
    icon: {
      src: GeometryIcon,
      alt: 'geometryIcon',
    },
  },
  {
    keyMatchers: ['probability', 'sannsynlighet', 'statystyka-ta-teoriya-ymovirnostey', 'statystyka-ta-ymovirnist'],
    image: {
      src: Statistics,
    },
    icon: {
      src: DiceIcon,
      alt: 'statisticsAndProbabilityIcon',
    },
  },
  {
    keyMatchers: ['statistics', 'statistikk', 'statystyka'],
    image: {
      src: Statistics,
    },
    icon: {
      src: CakeDiagramIcon,
      alt: 'statisticsIcon',
    },
  },
  {
    keyMatchers: ['economy', 'økonomi', 'okonomi', 'finansy'],
    image: {
      src: GraphIcon,
      alt: 'functionsIcon',
    },
    icon: {
      src: EconomyIcon,
      alt: 'economyIcon',
    },
  },

  {
    keyMatchers: ['functions', 'funksjoner', 'funktsiyi'],
    image: {
      src: Functions,
    },
    icon: {
      src: GraphIcon,
      alt: 'functionsIcon',
    },
  },
  {
    keyMatchers: ['proofs', 'bevis', 'dovedennya'],
    image: {
      src: Proofs,
    },
    icon: {
      src: EquivIcon,
      alt: 'proofsIcon',
    },
  },
  {
    keyMatchers: ['eksamen', 'exam', 'ispytu'],
    icon: {
      src: AlarmIcon,
      alt: 'overviewAndExamTipsIcon',
    },
  },
]

export function getImageData(key: string): ImageDataType | undefined {
  const lowercaseKey = key.toLowerCase()
  return imageData.find((data) => data.keyMatchers.some((matcher) => lowercaseKey.includes(matcher)))
}
